import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter } from '@angular/core';
import { ensurePane } from './leaflet.service';
import * as L from 'leaflet';
import { LeafletMapComponent } from './leaflet-map.component';

export interface TileError {
  url:string,
  resolved?:boolean
}

@Component({
  selector: 'tile-layer',
  template: '',
  styles: []
})
export class TileLayerComponent implements OnInit, OnChanges, OnDestroy {
  @Input() url: string;
//   @Input() params: any = {};
  @Input() zIndex = 10;
  @Input() opacity = 1;
  @Output() loaded = new EventEmitter();
  @Output() loading = new EventEmitter();
  @Output() tileError = new EventEmitter<TileError>();
  errored = false;
  private layer: L.TileLayer;

  constructor(private map:LeafletMapComponent) {
  }

  ngOnDestroy(): void {
    if(this.map.map){
      this.remove(this.map.map);
    }
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.map.withMap((m: L.Map) => {
      this.updateLayer();
    });
  }

  updateLayer(){
    const m = this.map.map;
    // this.map.map.then(m=>{
      this.remove(m);
      if(!this.url){
        return;
      }

      const pane = `wms-pane-${this.zIndex}`;
      ensurePane(m,pane,this.zIndex)
      const params:any = {
        pane,
        opacity: this.opacity
      };

      this.layer = L.tileLayer(this.url,params as L.TileLayerOptions);
      this.layer.on('loading',()=>{
        this.loading.emit();
      });
      this.layer.on('load',()=>{
        this.loaded.emit();
      });
      this.layer.on('tileerror',(e)=>{
        this.errored = true;
        this.tileError.emit({
          url:e.target._url
        });
      });
      this.layer.on('tileload',(e)=>{
        if(this.errored){
          this.tileError.emit({
            url:e.target._url,
            resolved:true
          })
        }
        this.errored = false;
      });
      // this.layer.options.noWrap = true;
      console.log('Adding tile layer',this.layer);
      this.layer.addTo(m);
    // });
  }

  remove(m: L.Map) {
    if(this.layer){
      this.layer.removeFrom(m);
      this.layer.off();
      this.layer = null;
    }
  }
}
